import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { SharedService, Status } from '.././shared/shared.service';
import { BaseComponent } from '.././shared/base.component';
// import { Message } from 'primeng/primeng';
import { PagerList, GlobalInfo, FPMessage, Severities, Country, RoleAccess, PageKey, ConversationMessage, NewNumber, NewGroup } from '.././shared/shared.model';
import { TranslateService } from '@ngx-translate/core';
import { TextChatService } from './textchat.service';
import { DataPassingService } from './data-passing.service';
import { UserListEntity, User, UserLookupFilter, Users, ShowPageEnum, ConvoMessage, ThumbnailImage, ThumbnailInput } from './textchat.model';
import { VideoChatService } from '../dispatch/video-chat/video-chat.service';
import * as _ from 'lodash';
declare var $: any;
import * as moment from 'moment';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { CapitalizeFirstPipe } from '.././shared/pipes/custom-pipes.pipe';
@Component({
    selector: 'textchat-popup',
    templateUrl: 'textchat-popup.component.html',
    styleUrls: ['./textchat-popup.css']
})
export class TextChatPopupComponent extends BaseComponent implements OnInit {

    @Output() done = new EventEmitter();
    currentUserName: string = '';
    frmTextChat: FormGroup;
    conversationUsers: any;
    conversationList: any;
    selectedUser: any = {};
    showOnline: any;
    messageArray: any[] = [];
    public totalNotifcationCount: number = 0;
    currentUserID: string;
    chatUsers: any;
    showUsers: boolean = false;
    currentUser: User = new User();
    public rows: number;
    public page: number;
    public order: string;
    public sortby: string;
    public rowsperOptions: any;
    public getRows: number;
    filteroptionId: number = 1;
    stacked: boolean;
    togglelist: boolean = false;
    pageCount: number = 1;
    public filterdetails: UserLookupFilter;
    public usersval: User[] = [];
    public usersList: User[] = [];
    showPage: ShowPageEnum = 0;//0-RecentConvo,1-ConvoMessage,2-UsersList,3-CreateNewGroup,4-UserSettings,5-UserProfile
    gi: GlobalInfo;
    logedinUser: User = new User();
    img: ThumbnailImage[] = [];
    public conversationmessage: ConversationMessage = new ConversationMessage();
    public addnumbers: NewNumber = new NewNumber();
    // public newNumber: NewNumber;

    /*GroupConversation Declaration */
    channels: any = [];
    messages: any = [];
    friendlyName: any;
    Sid: string;
    selectedChannel: any;

    channelEnterCheck: boolean = false;
    newNumberShow: boolean = false;
    sid: any;
    identity: any;
    newGroupshow: boolean = false;
    public addgroups: NewGroup = new NewGroup();
    constructor(protected sharedService: SharedService, private route: ActivatedRoute, protected translate: TranslateService,
        private formBuilder: FormBuilder, public chatProvider: TextChatService,
        public dataPassingService: DataPassingService, private location: Location, private videoChatService: VideoChatService, private http: HttpClient) {
        super(sharedService, translate);
        this.gi = this.globalInfo();
        // if(this.channelEnterCheck == true){
        //     setTimeout(function () {
        //        this.enterChannel(this.selectedChannel)                    
        //     }, 100);
        // }

    }
    ngOnInit() {

        this.getChannels();



        this.currentUserID = this.globalInfo().Email;
        this.frmTextChat = this.formBuilder.group({
            message: ['']
        });
        if (this.filterdetails == null) {
            this.filterdetails = new UserLookupFilter();
        }
        this.rows = this.getRows;
        this.page = 0;
        this.order = "DisplayName";
        this.sortby = "Asc";

        //  this.chatProvider.startSubscribe();
        var org = {
            "org": {
                "name": this.globalInfo().CompanyCode,
                "orgId": this.globalInfo().CompanyId
            }
        };
        this.chatProvider.registerOrg(org).then(t => {
        });

        this.loadAllUsers();
        // this.getConversationList();

        this.totalNotifcationCount = _.sumBy(this.conversationList, 'notification');
        this.dataPassingService.getApperance().subscribe(data => {
            this.updateUserstatus(data);
        });
    }


    newConvoOnClick() {
        this.filterdetails.SortBy = this.sortby;
        this.filterdetails.OrderBy = this.order;
        this.filterdetails.StartRecord = this.page;
        this.filterdetails.EndRecord = this.rows;
        this.filterdetails.CompanyID = this.globalInfo().CompanyId;
        this.filterdetails.LoginId = this.globalInfo().LoginId;
        this.filterdetails.MaxRoleGroup = this.globalInfo().MaxRoleGroup;
        this.filterdetails.VendorId = this.globalInfo().VendorId;
        this.videoChatService.getUsers(this.filterdetails.CompanyID, this.filterdetails.LoginId, 0, 0, this.filterdetails.StartRecord, this.filterdetails.EndRecord, this.filterdetails.SortBy, this.filterdetails.OrderBy).subscribe(resp => {
            this.showPage = 2;
            this.pageCount = resp.TotalRecord;
            var imput: ThumbnailInput[] = [];
            var userl = resp.UserListModel;
            userl.forEach(m => {
                if (m.PhotoPath)
                    imput.push({ LoginId: m.LoginId, fileName: m.PhotoPath, EmailId: m.Email });
                else
                    m.attachment = '';
            });
            this.videoChatService.getUserThumbnail(this.globalInfo().CompanyId, imput).subscribe(p => {
                p.forEach(b => {
                    var ind = userl.findIndex(fi => fi.LoginId == b.LoginId);
                    if (ind != -1) {
                    }
                    userl[ind].attachment = b.attachment;
                });
                this.img = p;
                this.usersList = userl;
                this.usersval = userl;
                this.logedinUser = this.usersList.find(f => f.LoginId == this.gi.LoginId);
            });
        });
    }
    loadAllUsers() {
        this.filterdetails.SortBy = this.sortby;
        this.filterdetails.OrderBy = this.order;
        this.filterdetails.StartRecord = this.page;
        this.filterdetails.EndRecord = this.rows;
        this.filterdetails.CompanyID = this.globalInfo().CompanyId;
        this.filterdetails.LoginId = this.globalInfo().LoginId;
        this.filterdetails.MaxRoleGroup = this.globalInfo().MaxRoleGroup;
        this.filterdetails.VendorId = this.globalInfo().VendorId;
        this.videoChatService.getUsers(this.filterdetails.CompanyID, this.filterdetails.LoginId, 0, 0, this.filterdetails.StartRecord, this.filterdetails.EndRecord, this.filterdetails.SortBy, this.filterdetails.OrderBy).subscribe(resp => {
            this.pageCount = resp.TotalRecord;
            var imput: ThumbnailInput[] = [];
            var userl = resp.UserListModel;
            userl.forEach(m => {
                if (m.PhotoPath)
                    imput.push({ LoginId: m.LoginId, fileName: m.PhotoPath, EmailId: m.Email });
                else
                    m.attachment = '';
            });
            this.videoChatService.getUserThumbnail(this.globalInfo().CompanyId, imput).subscribe(p => {
                p.forEach(b => {
                    var ind = userl.findIndex(fi => fi.LoginId == b.LoginId);
                    if (ind != -1) {
                        userl[ind].attachment = b.attachment;
                    }
                });
                this.img = p;
                this.usersList = userl;
                this.usersval = userl;
                this.logedinUser = this.usersList.find(f => f.LoginId == this.gi.LoginId);
                this.getConversationList();
            });
        });
    }
    closeUsers() {
        this.showUsers = false;
    }
    onUserListSearch(text: string) {
        this.usersval = this.usersList.filter(f => f.DisplayName.toLowerCase().startsWith(text.trim().toLowerCase()) == true || f.DisplayName.toLowerCase().endsWith(text.trim().toLowerCase()));
    }
    onConvoListSearch(text: string) {
        this.conversationUsers = this.conversationList.filter(f => f.username.toLowerCase().startsWith(text.trim().toLowerCase()) == true || f.username.toLowerCase().endsWith(text.trim().toLowerCase()));
    }
    openChatFromModel(user: User) {
        this.currentUser = user;
        this.showUsers = false;
        var studentRecord: any = _.find(this.conversationList, { 'receiver_id': (user.Email).toString() });

        if (studentRecord) {
            var data1 = {
                username: user.DisplayName,
                conversation_id: studentRecord ? studentRecord.conversation_id : '',
                receiver_id: user.Email,
                online: ''
            }
            this.getConversationById(data1, 'chatUser');
        }
        else {
            var reg = {
                "user":
                {
                    "name": user.DisplayName.length >= 6 ? user.DisplayName : user.FirstName + " " + user.LastName,
                    "userid": user.Email,
                    "picture": "",
                    "org_id": this.globalInfo().CompanyId
                }
            };
            this.chatProvider.registerUser(reg).then(m => {               
                var data = { 'receiver_id': user.Email, 'personal_message': { 'body': 'Hi' } };
                this.chatProvider.getUsers().then(tn => {
                    var Tn: any = tn;
                    var ui = Tn.user.findIndex(fi => fi.email == user.Email);
                    var us = Tn.user[ui];
                    this.chatProvider.createPost(data).then((result: any) => {

                        if (result.status_message == 'Success') {
                            this.frmTextChat.reset();
                            this.messageArray = [];
                            // if (this.messageArray.length == 0) {
                            var output = { 'body': data.personal_message.body, 'posted_at': moment().format(), UserId: this.currentUserID }
                            var data1 = {
                                username: user.DisplayName,
                                conversation_id: result.conversation_id,
                                receiver_id: user.Email,
                                online: ''
                            }
                            this.getConversationById(data1, 'ModelPopup');
                            this.updateNewUser(result.conversation_id, output);
                            // }
                        }
                    });
                });

            });

        }

    }
    getConversationList() {
        this.chatProvider.getHomeConversations().then((result: any) => {

            if (result.data == undefined || result.data.length <= 0) {
                var reg = {
                    "user":
                    {
                        "name": this.globalInfo().DisplayName,
                        "userid": this.globalInfo().Email,
                        "picture": "",
                        "org_id": this.globalInfo().CompanyId
                    }
                };
                this.chatProvider.registerUser(reg).then(m => {

                });
            }
            else {
                result.data.map(x => {
                    let disp = this.usersList.find(cl => cl.Email == x.receiver_id);
                    if (disp) {
                        x.username = disp.DisplayName;
                        x.attachment = disp.attachment;
                    }

                    else {
                        x.username = '';
                        x.attachment = '';
                    }
                });
                this.conversationUsers = result.data.reverse();
                this.conversationList = result.data; 
            }
        });
    }
    updateUserstatus(data) {
        let statusModal: any = data;
        if (!_.isEmpty(this.selectedUser) && (statusModal.online == true || statusModal.online == false)) {
            if (this.selectedUser.receiver_id == statusModal.UserId) {
                this.currentUser.online = data.online;
            }
        } else {
            if (statusModal.online == true || statusModal.online == false) {
                if (_.find(this.conversationList, { 'receiver_id': statusModal.UserId })) {
                    var index = _.findIndex(this.conversationList, { 'receiver_id': statusModal.UserId });
                    this.conversationList[index].online = data.online;
                }
            }
        }
        this.conversationUsers = this.conversationList.filter(f => 1 == 1);
    }
    updateConversationPage(obj) {
        if (_.find(this.conversationList, { 'conversation_id': obj.conversation_id })) {
            if (!_.find(this.conversationList, { 'posted_at': obj.posted_at })) {
                var index = _.findIndex(this.conversationList, { 'conversation_id': obj.conversation_id });
                this.conversationList[index].body = obj.body;
                this.conversationList[index].posted_at = obj.posted_at;
                if (obj.notification) {
                    this.conversationList[index].notification = this.conversationList[index].notification ? this.conversationUsers[index].notification + 1 : 1;
                    this.totalNotifcationCount = _.sumBy(this.conversationList, 'notification');
                }
            }
        } else {
            // New Message from New user
            obj.notification = 1;
            this.conversationList.unshift(obj);
            this.totalNotifcationCount = _.sumBy(this.conversationList, 'notification');
        }
        this.conversationUsers = this.conversationList.filter(f => 1 == 1);
    }
    getConversationById(conversation, from1) {
        this.messageArray = [];
        // Clear Notification Count    
        this.totalNotifcationCount = this.totalNotifcationCount - parseInt(conversation.notification);
        conversation.notification = '';
        this.showOnline = conversation.online;
        // Get list of conversation Messages by conversation ID
        this.selectedUser = conversation;
        this.currentUser = this.usersList.find(d => d.Email == conversation.receiver_id);
        this.userStatus();
        this.showPage = 1;
        if (conversation.conversation_id) {
            this.chatProvider.getConversationsHome(conversation.conversation_id).then((result: any) => {
                var source = result.data;
                source.map(c => {
                    c.posted_atstr = new Date(c.posted_at).toDateString();
                });
                var curr = '';
                source.forEach(c => {
                    if (curr != c.posted_atstr) {
                        var a = _.clone(c, true);
                        var b = _.clone(c, true);
                        curr = a.posted_atstr;
                        if (c.posted_atstr == new Date().toDateString())
                            a.posted_atstr = 'Today';
                        a.type = 0;
                        this.messageArray.push(a);
                        b.type = 1;
                        this.messageArray.push(b);
                    }
                    else {
                        c.type = 1;
                        this.messageArray.push(c);
                    }
                });
                setTimeout(function () {
                    if ($('.onlinechat-messages'))
                        $('.onlinechat-messages').animate({ scrollTop: $('.onlinechat-messages')[0].scrollHeight }, "slow");
                }, 300);
            });
        } else {
            this.messageArray = [];
        }
    }

    sendMessage(formData, dt) {

        if (formData.value.message) {

            this.conversationmessage.Identity = this.identity;
            this.conversationmessage.ConversationSid = this.sid;
            this.conversationmessage.Message = formData.value.message;


            this.sharedService.SendGroupMessage(this.conversationmessage).subscribe(resp => {
                (<HTMLInputElement>document.getElementById('messagetyping')).value = "";
                if (resp == 1) {
                    this.enterChannel(this.selectedChannel);
                }
            });
        }
    }
    updateNewUser(conversation_id, messageData) {
        this.selectedUser.conversation_id = conversation_id;
        var ind = this.img.findIndex(fi => fi.EmailId == this.selectedUser.receiver_id);
        var att = '';
        if (ind != -1) {
            att = this.img[ind].attachment;
        }

        var obj = {
            username: this.selectedUser.username,
            body: messageData.body,
            posted_at: messageData.posted_at,
            conversation_id: this.selectedUser.conversation_id,
            receiver_id: this.selectedUser.receiver_id,
            online: this.selectedUser.online,
            attachment: att
        }
        this.conversationList.unshift(obj);
        this.conversationUsers = this.conversationList.filter(f => 1 == 1);
    }
    leftPaneltoggle() {
        super.LeftPanelToggle();
    }
    toggled: boolean = false;
    handleSelection(event) {
        if (event.char == null || event.char == 'null') {
            return;
        }
        var val = this.frmTextChat.controls['message'].value + event.char;
        this.frmTextChat.controls['message'].setValue(val);
    }
    clearAllMessage() {
        this.chatProvider.clearAllMessage(this.selectedUser.conversation_id).then(m => {
            this.getConversationById(this.selectedUser, '');
        });
    }
    showPagezero() {
        // this.currentUser = null;
        // this.selectedUser = {};
        // this.getConversationList();
        // this.showPage = 0;
        this.newNumberShow = false;
        this.newGroupshow = false;
        this.showPage = 0;
        this.getChannels();
    }
    showPageFive() {
        this.userStatus();
        this.showPage = 5;
    }
    userStatus() {
        this.chatProvider.getUserStatus(this.currentUser.Email).then((result: any) => {
            
            if (result.status == 200) {
                this.currentUser.online = result.data.online;
            }
        });
    }

    //GroupConversation Start
    getChannels() {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + btoa('ACded62239d5a18085578327088ea78f96:e71f60a24c9317a367b8a75805fa3a80')
            })
        };

        this.http.get("https://conversations.twilio.com/v1/Conversations/",
            httpOptions).subscribe((res: Response) => {
                this.channels = res['conversations'];
            });
    }


    enterChannel(selectedChannel) {
        this.showPage = 1;
        this.messages = [];
        this.selectedChannel = selectedChannel
        this.channelEnterCheck = true;
        this.friendlyName = this.selectedChannel.friendly_name;

        this.sid = this.selectedChannel.sid;

        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + btoa('ACded62239d5a18085578327088ea78f96:e71f60a24c9317a367b8a75805fa3a80')
            })
        };

        this.http.get(selectedChannel.links.messages,
            httpOptions).subscribe((res: Response) => {
                for (let i = 0; i < res['messages'].length; i++) {
                    this.identity = res['messages'][0].author;
                    this.messages.push(res['messages'][i]);
                }
                this.scrollToBottom();
            });
    }

    scrollToBottom() {
        setTimeout(() => {
            const container = document.getElementById("chatDisplay");
            //scroll down
            container.scrollTop = container.scrollHeight;
        }, 500);
    }

    addNewMember() {
        this.newNumberShow = true;
    }
    refresh() {
        if (this.selectedChannel.sid) {
            this.enterChannel(this.selectedChannel);
        }

    }
    addNumber() {
        var inputValue = (<HTMLInputElement>document.getElementById('phnnumber')).value;
        this.addnumbers.Number = inputValue;
        this.addnumbers.ConversationSid = this.sid;
        this.sharedService.AddNewNumber(this.addnumbers).subscribe(resp => {


            if (resp != 0) {

                this.sharedService.notification.emit({
                    severity: Severities[0],
                    summary: CapitalizeFirstPipe.prototype.transform(Severities[0]),
                    detail: this.translate.instant("Member Added Successfully")
                });


            }
            else {

                this.sharedService.notification.emit({
                    severity: Severities[1],
                    summary: CapitalizeFirstPipe.prototype.transform(Severities[1]),
                    detail: this.translate.instant("Member Already Exists")
                });
            }

            this.newNumberShow = false;
            this.newGroupshow = false;
        });

    }

    newGroupClick() {

        this.newGroupshow = true;

    }
    addgroup() {

        var groupName = (<HTMLInputElement>document.getElementById('groupName')).value;
        // groupphonenumbers = (<HTMLInputElement>document.getElementById('groupnumber')).value;

        // this.addgroups.Numbers = groupphonenumbers;
        this.addgroups.ConversationSid = this.sid;
        this.addgroups.Groupname = groupName;

        this.sharedService.AddNewGroup(this.addgroups).subscribe(resp => {


            if (resp != 0) {

                this.sharedService.notification.emit({
                    severity: Severities[0],
                    summary: CapitalizeFirstPipe.prototype.transform(Severities[0]),
                    detail: this.translate.instant("Group Added Successfully")
                });

                this.getChannels();
            }
            else {

                this.sharedService.notification.emit({
                    severity: Severities[1],
                    summary: CapitalizeFirstPipe.prototype.transform(Severities[1]),
                    detail: this.translate.instant("Group Already Exists")
                });
            }

            //console.log(inputValue);
            this.newNumberShow = false;
            this.newGroupshow = false;
        });

    }
}
